export const body_email = (enlace, nombre_programa, nombre_estudiante) => {
  return `
  <!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Términos y condiciones</title>
</head>

<body style="
  margin: 0;
  padding: 0;
  background-color: #f3f5f8;
  font-family: Arial, Helvetica, sans-serif;
  color: #263238;
">
  <table
    role="presentation"
    width="100%"
    cellspacing="0"
    cellpadding="0"
    border="0"
    style="background-color: #f3f5f8;"
  >
    <tr>
      <td align="center" style="padding: 32px 15px;">

        <table
          role="presentation"
          width="100%"
          cellspacing="0"
          cellpadding="0"
          border="0"
          style="
            max-width: 620px;
            background-color: #ffffff;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 18px rgba(0, 0, 0, 0.08);
          "
        >

          <!-- Encabezado -->
          <tr>
            <td
              align="center"
              style="
                background-color: #123b66;
                padding: 30px 25px;
                color: #ffffff;
              "
            >
              <div style="
                font-size: 13px;
                letter-spacing: 1.5px;
                text-transform: uppercase;
                opacity: 0.85;
                margin-bottom: 10px;
              ">
                Información académica
              </div>

              <h1 style="
                margin: 0;
                font-size: 27px;
                line-height: 1.3;
                font-weight: 700;
              ">
                Términos y condiciones
              </h1>
            </td>
          </tr>

          <!-- Contenido -->
          <tr>
            <td style="padding: 36px 35px 20px 35px;">

              <p style="
                margin: 0 0 18px 0;
                font-size: 16px;
                line-height: 1.7;
              ">
                Estimado(a) estudiante:
              </p>
              <p style="
                margin: 0 0 18px 0;
                font-size: 16px;
                line-height: 1.0;
              ">${nombre_estudiante}</p>

              <p style="
                margin: 0 0 18px 0;
                font-size: 16px;
                line-height: 1.7;
              ">
                Como parte de su proceso académico en el programa
                <strong>${nombre_programa}</strong>, le enviamos el acceso
                a nuestros términos y condiciones.
              </p>

              <p style="
                margin: 0 0 26px 0;
                font-size: 16px;
                line-height: 1.7;
              ">
                Le recomendamos leer cuidadosamente la información antes de
                continuar con el proceso correspondiente.
              </p>

              <!-- Botón -->
              <table
                role="presentation"
                width="100%"
                cellspacing="0"
                cellpadding="0"
                border="0"
              >
                <tr>
                  <td align="center" style="padding: 8px 0 28px 0;">
                    <a
                      href="${enlace}"
                      target="_blank"
                      style="
                        display: inline-block;
                        background-color: #1769aa;
                        color: #ffffff;
                        text-decoration: none;
                        font-size: 16px;
                        font-weight: bold;
                        padding: 15px 30px;
                        border-radius: 7px;
                      "
                    >
                      Revisar términos y condiciones
                    </a>
                  </td>
                </tr>
              </table>

              <!-- Aviso -->
              <table
                role="presentation"
                width="100%"
                cellspacing="0"
                cellpadding="0"
                border="0"
                style="
                  background-color: #f5f8fc;
                  border-left: 4px solid #1769aa;
                  border-radius: 4px;
                "
              >
                <tr>
                  <td style="padding: 17px 18px;">
                    <p style="
                      margin: 0;
                      font-size: 14px;
                      line-height: 1.6;
                      color: #455a64;
                    ">
                      Este enlace está relacionado con su programa académico.
                      Evite compartirlo con terceras personas.
                    </p>
                  </td>
                </tr>
              </table>

              <p style="
                margin: 26px 0 8px 0;
                font-size: 14px;
                line-height: 1.6;
                color: #607d8b;
              ">
                Si el botón no funciona, copie y pegue el siguiente enlace en
                su navegador:
              </p>

              <p style="
                margin: 0;
                font-size: 13px;
                line-height: 1.6;
                word-break: break-all;
              ">
                <a
                  href="${enlace}"
                  target="_blank"
                  style="color: #1769aa; text-decoration: underline;"
                >
                  ${enlace}
                </a>
              </p>

            </td>
          </tr>

          <!-- Pie -->
          <tr>
            <td
              align="center"
              style="
                padding: 25px 35px 30px 35px;
                border-top: 1px solid #e8edf2;
              "
            >
              <p style="
                margin: 0 0 7px 0;
                font-size: 14px;
                font-weight: bold;
                color: #37474f;
              ">
                Atentamente,<br>
                Departamento Académico
              </p>

              <p style="
                margin: 0;
                font-size: 12px;
                line-height: 1.5;
                color: #90a4ae;
              ">
                Este es un correo informativo enviado como parte de su proceso
                académico.
              </p>
            </td>
          </tr>

        </table>

      </td>
    </tr>
  </table>
</body>
</html>
  `
}